module.exports = {"TXTCLI_Confirm_Details":{"id":"TXTCLI_Confirm_Details","defaultMessage":"Confirmer les informations","track":"Confirm Details"}}